import React from 'react';
import { MetricCountBySelection } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/metric-count-by-menu';
import type { RowProps } from '../catalog';
export function SimpleMetricMeasurement(props: RowProps) {
  return <div data-sentry-component="SimpleMetricMeasurement" data-sentry-source-file="measurement.tsx">
      <MetricCountBySelection {...props} data-sentry-element="MetricCountBySelection" data-sentry-source-file="measurement.tsx" />
    </div>;
}